import { FetchContext } from '../fetch-context';
import { EventAttendee } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const updateEventAttendee: (
  fetchContext: FetchContext,
  eventAttendeeId: number,
  eventAttendee: EventAttendee,
  accessToken?: string,
) => Promise<void> = (fetchContext, eventAttendeeId, eventAttendee, accessToken) => {
  return fetch(`${fetchContext.baseUrl}/api/event-attendees/${eventAttendeeId}`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(eventAttendee),
  }).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update event attendee'));
};
